import * as AppUrl from './appUrl'

const urlPermissionMappings = [
  {url: AppUrl.FORBIDDEN, title: '', ignore: true},
  {url: AppUrl.NOTFOUND, title: '', ignore: true},

  {title: '', url: AppUrl.HOME, pKey: 'home'},
  {title: 'Permission Management', url: AppUrl.PERMISSIONMANAGEMENT, pKey: 'permissionManagement'},
  {title: 'User Management', url: AppUrl.USERMANAGEMENT, pKey: 'userManagement'},
  {title: 'Role Management', url: AppUrl.ROLEMANAGEMENT, pKey: 'roleManagement'},
  {title: 'Approve Permission', url: AppUrl.APPROVEPERMISSION, pKey: 'approvePermission'},
  {title: 'Business Type', url: AppUrl.BUSINESSTYPE, pKey: 'businessType'},
  {title: 'Customer Management', url: AppUrl.CUSTOMERMANAGEMENT, pKey: 'customerManagement'},
  {title: 'Customer Master Data', url: AppUrl.CUSTOMERMASTERDATA, pKey: 'customerMasterData'},
  {title: 'Mapping Management', url: AppUrl.MAPPINGMANAGEMENT, pKey: 'mappingManagement'},
  {title: 'Message Overview', url: AppUrl.MESSAGEMANAGEMENT, pKey: 'messageManagement'},
  {title: 'Message Details', url: AppUrl.MESSAGEDETAILS, pKey: 'messageDetails'},
  {title: 'Index Management', url: AppUrl.INDEXMANAGEMENT, pKey: 'indexManagement'},
  {title: 'Message Payload', url: AppUrl.MESSAGEPAYLOAD, pKey: 'messagePayload'},
  {title: 'Index Search', url: AppUrl.INDEXSEARCH, pKey: 'indexSearch'},
  {title: 'Connect Management', url: AppUrl.APIMANAGEMENT, pKey: 'apiManagement'},
  {title: 'Data Target', url: AppUrl.DATATARGET, pKey: 'dataTarget'},
  {title: 'Data Source', url: AppUrl.DATASOURCE, pKey: 'dataSource'},
  {title: 'Azure App Registration', url: AppUrl.AZUREAPPREGISTRATION, pKey: 'azureAppRegistration'},
  {title: 'Azure KeyVault', url: AppUrl.AZUREKEYVAULT, pKey: 'azureKeyVault'},
  {title: 'Connection Monitor', url: AppUrl.CONNECTIONMONITOR, pKey: 'connectionMonitor'},
  {title: 'Transportation', url: AppUrl.TRANSPORTATION, pKey: 'transportation'},
  {title: 'Mass Resend', url: AppUrl.MASSRESEND, pKey: 'massResend'},
  {title: 'Upload Data Resource', url: AppUrl.UPLOADDATARESOURCE, pKey: 'uploadDataResource'},
  {title: 'Stream Management', url: AppUrl.STREAMMANAGEMENT, pKey: 'streamManagement'},
  {title: 'Job', url: AppUrl.JOBMANAGEMENT, pKey: 'jobManagement'},
  {title: 'Groovy Management', url: AppUrl.GROOVYMANAGEMENT, pKey: 'groovyManagement'},
  {title: 'E-Billing Report', url: AppUrl.REPORTEBILLING, pKey: 'reportEBilling'},
  {title: 'RTM Order Report', url: AppUrl.REPORTORDER, pKey: 'reportOrder'},
  {title: 'WEB EDI', url: AppUrl.WEBEDI, pKey: 'webEDI'},
  {title: 'Ship To', url: AppUrl.SHIPTO, pKey: 'shipTo'},
  {title: 'User Email Management', url: AppUrl.USEREMAILMANAGEMENT, pKey: 'userEmailManagement'},
  {title: 'Formula Info', url: AppUrl.FORMULAINFO, pKey: 'formulaInfo'},
  {title: 'Formula Type', url: AppUrl.FORMULATYPE, pKey: 'formulaType'},
  // {title: 'Rules Management', url: AppUrl.RULESMANAGEMENT, pKey: 'rulesManagement'},
  {title: 'Email Management', url: AppUrl.EMAILMANAGEMENT, pKey: 'emailManagement'},
  {title: 'CHAT BI', url: AppUrl.CHATBI, pKey: 'chat'},
  {title: 'Harness', url: AppUrl.HARNESS, pKey: 'harness'},

  {title: 'Connect', url: AppUrl.HOME, pKey: 'apiManage'},
  {title: 'Tools', url: AppUrl.HOME, pKey: 'apiTools'},
  {title: 'Authorization', url: AppUrl.HOME, pKey: 'permission'},
  {title: 'Audit Logs', url: AppUrl.AUDITLOGS, pKey: 'auditLogs'},
  {title: 'Report Management', url: AppUrl.REPORTMANAGEMENT, pKey: 'reportManagement'},
  {title: 'Report Tag', url: AppUrl.REPORTTAG, pKey: 'reportTag'},
  {title: 'Report', url: AppUrl.REPORTPAGE, pKey: 'reportPage'},
  {title: 'Report with ID', url: AppUrl.REPORTPAGE_WITH_ID, pKey: 'reportPage'},
  {title: 'PowerBI Report', url: AppUrl.PBIREPORTPAGE, pKey: 'pbiReportPage'},
  {title: 'PowerBI Report with ID', url: AppUrl.PBIREPORTPAGE_WITH_ID, pKey: 'pbiReportPage'},
  {title: 'Data Flow Monitoring Configuration', url: AppUrl.DATAFLOWMONITORINGCONFIG, pKey: 'dataFlowMonitoringConfig'},
  {title: 'Data Flow Logs', url: AppUrl.DATAFLOWLOG, pKey: 'dataFlowLog'},


  {title: 'Marketing Group Management', url: AppUrl.MARKETINGGROUPMANAGEMENT, pKey: 'marketingGroupManagement'},
  {title: 'Resource Pool', url: AppUrl.RESOURCEPOOL, pKey: 'resourcePool'},
  {title: 'Address Book', url: AppUrl.ADDRESSBOOK, pKey: 'addressBook'},
  {title: 'Short Link Management', url: AppUrl.SHORTLINK, pKey: 'shortLink'},
  {title: 'SMS', url: AppUrl.SMS, pKey: 'sms'},
  {title: 'SMS Signature', url: AppUrl.SMSSIGNATURE, pKey: 'smsSignature'},
  {title: 'SMS Template', url: AppUrl.SMSTEMPLATE, pKey: 'smsTemplate'},
  {title: 'SMS Management', url: AppUrl.SMSMANAGEMENT, pKey: 'smsManagement'},
  {title: 'SMS Management Details', url: AppUrl.SMSMANAGEMENTDETAILS, pKey: 'smsManagementDetails'},
  {title: 'Email Send', url: AppUrl.EMAILSEND, pKey: 'emailSend'},
  {title: 'Email Address', url: AppUrl.EMAILADDRESS, pKey: 'emailAddress'},
  {title: 'Email Template', url: AppUrl.EMAILTEMPLATE, pKey: 'emailTemplate'},
  {title: 'Email Send Online', url: AppUrl.EMAILSENDONLINE, pKey: 'emailSendOnline'},
  {title: 'Email List', url: AppUrl.EMAILLIST, pKey: 'emailList'},
  {title: 'Fatigue Config', url: AppUrl.FATIGUECONFIG, pKey: 'fatigueConfig'},
  {title: 'Manual Call', url: AppUrl.MANUALCALL, pKey: 'manualCall'},
  {title: 'Remark Template List', url: AppUrl.REMARKTEMPLATELIST, pKey: 'remarkTemplateList'},
  {title: 'Manual Call Management', url: AppUrl.MANUALCALLMANAGEMENT, pKey: 'manualCallManagement'},
  {title: 'Intelligent Call', url: AppUrl.INTELLIGENTCALL, pKey: 'intelligentCall'},
  {title: 'Intelligent Call Model', url: AppUrl.INTELLIGENTCALLMODEL, pKey: 'intelligentCallModel'},
  {title: 'Intelligent Call Management', url: AppUrl.INTELLIGENTCALLMANAGEMENT, pKey: 'intelligentCallManagement'},
  {title: 'Intelligent Call Details', url: AppUrl.INTELLIGENTCALLDETAILS, pKey: 'intelligentCallDetails'},

  {title: 'Mice Cad Oea', url: AppUrl.MICECADOEA, pKey:'miceCadOea'},
  {title: 'Mice Cad Oea Schedule', url: AppUrl.MICECADOEASCHEDULE, pKey:'miceCadOeaSchedule'},
  {title: 'Theme Setting', url: AppUrl.THEMESETTING, pKey:'themeSetting'},

  {title: 'Drive List', url: AppUrl.DRIVELIST, pKey:'driveList'},
  {title: 'Drive Permission', url: AppUrl.DRIVEPERMISSION, pKey:'drivePermission'},
  {title: 'Drive Search', url: AppUrl.DRIVESEARCH, pKey:'driveSearch'},

  {title: 'Terminology Config', url: AppUrl.TERMINOLOGYCONFIG, pKey:'terminologyConfig'},
  {title: 'SQL Example', url: AppUrl.SQLEXAMPLE, pKey:'sqlExample'},
  {title: 'Query Audit', url: AppUrl.QUERYAUDIT, pKey:'queryAudit'},
]

export default urlPermissionMappings
